import React, { useState, useEffect } from 'react'
import QuestionItem from '@/component/question/question'
import './result.scss'
import { jqImage } from '@/api/url'
import { getItem } from '@/utils/storage'
import { formattedText } from '@/utils/tool'

const ExamResult = () => {
  const [result, setResult] = useState(null)

  useEffect(() => {
    const storedResult = getItem('examResult')
    setResult(storedResult)
  }, [])

  const getMyAnswerOption = (question) => question?.userAnswer?.option

  const isAnswerRight = (question) => {
    return question?.userAnswer?.result === 1
  }

  const getMyAnswer = (question) => {
    const myOption = getMyAnswerOption(question)
    if (!myOption) return '未作答'
    const answer = JSON.parse(question.answer)
    const userSelectOption = answer.options.find(
      (option) => option.option === myOption
    )
    return userSelectOption?.answer
  }

  if (!result) return null

  return (
    <div className="word-paper-wrap">
      <div className="word-paper">
        <div className="result">
          <img
            className={result.score >= 100 ? 'success' : 'fail'}
            src={
              result.score >= 100
                ? jqImage('/static/exam/exercise_success.gif')
                : jqImage('/static/exam/exercise_fail.gif')
            }
            alt="result"
          />
          <div className={`point ${result.score < 80 ? 'point-fail' : ''}`}>
            {result.score}分
          </div>
          <div className="point-text">
            {result.score < 80
              ? '很遗憾，本次测试不合格'
              : '恭喜你，通过本次测试'}
          </div>
          <div className="question-info">
            <span className="tag">答对：</span>
            <span className="content right">{result.rightCount}</span>
            <span className="tag">答错：</span>
            <span className="content wrong">{result.wrongCount}</span>
          </div>
        </div>
        <div className="main">
          <div className="module-contain">
            {result.questions && result.questions.length > 0 && (
              <div className="translate">
                <ul>
                  {result.questions.map((question, index) => (
                    <li key={question.id || index}>
                      <QuestionItem question={question} index={index} />
                      {!isAnswerRight(question) && (
                        <div className="your-answer">
                          <span className="tag">你的作答:</span>
                          <span className="option">
                            {getMyAnswerOption(question)
                              ? `${getMyAnswerOption(question)}.`
                              : ''}
                          </span>
                          <span
                            dangerouslySetInnerHTML={{
                              __html: formattedText(getMyAnswer(question)),
                            }}
                          ></span>
                        </div>
                      )}
                      <div className="judge">
                        <img
                          className="img"
                          src={
                            isAnswerRight(question)
                              ? jqImage('/static/word/result_right.png')
                              : jqImage('/static/word/result_wrong.png')
                          }
                          alt="judge"
                        />
                      </div>
                    </li>
                  ))}
                </ul>
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  )
}

export default ExamResult
